import Typography from "@material-ui/core/Typography";
import * as React from "react";
import TranslatedMessage from "../../../translations/TranslatedMessage";

type FaqLinkProps = {
  link: string;
  linkText: string;
};

const FaqLink: React.FunctionComponent<FaqLinkProps> = ({
  link,
  linkText,
}) => {
  return (
    <Typography component="div">
      <TranslatedMessage id="startCertification.paymentAndCompletionStep.generalInfo.moreInformation1" />
      <a href={link} target="_blank" rel="noopener noreferrer">
        {linkText}
      </a>
      <TranslatedMessage id="startCertification.paymentAndCompletionStep.generalInfo.moreInformation2" />
    </Typography>
  );
};

export default FaqLink;
